import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@/app/core/services/auth.service';

/**
 * Route guard that protects routes requiring authentication
 * Redirects to sign-in page if user is not authenticated
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isUserAuthenticated()) {
    return true;
  }

  // Redirect to sign-in page if not authenticated
  return router.createUrlTree(['/auth/sign-in']);
};
